import AlertDialog from "../../common/AlertDialog";
import SuccessRibbon from "../../common/SuccessRibbon";
import ErrorRibbon from "../../common/ErrorRibbon";
import { useClientDetails } from "../context/clientDetailsContext";

function Alerts() {
  const {
    linkToHubspot,
    linkToStripe,
    sendInviteEmail,
    client,
    updateClientDetails,
    replaceMainUser,
    addInvestment,
  } = useClientDetails();
  const { details } = client;

  const email = details?.mainUser?.email || "";

  return (
    <>
      <ErrorRibbon
        data={{
          details: linkToHubspot.alert,
          setAlert: linkToHubspot.setAlert,
        }}
      />
      <ErrorRibbon
        data={{
          details: linkToStripe.alert,
          setAlert: linkToStripe.setAlert,
        }}
      />
      <ErrorRibbon
        data={{
          details: sendInviteEmail.alert,
          setAlert: sendInviteEmail.setAlert,
        }}
      />
      <ErrorRibbon
        data={{
          details: addInvestment.alert,
          setAlert: addInvestment.setAlert,
        }}
      />
      <SuccessRibbon
        data={{
          details: addInvestment.alert,
          setAlert: addInvestment.setAlert,
        }}
      />
      <SuccessRibbon
        data={{
          details: linkToHubspot.alert,
          setAlert: linkToHubspot.setAlert,
        }}
      />
      <SuccessRibbon
        data={{
          details: updateClientDetails.alert,
          setAlert: updateClientDetails.setAlert,
        }}
      />
      <SuccessRibbon
        data={{
          details: replaceMainUser.alert,
          setAlert: replaceMainUser.setAlert,
        }}
      />
      <SuccessRibbon
        data={{
          details: linkToStripe.alert,
          setAlert: linkToStripe.setAlert,
        }}
      />
      <AlertDialog
        handleClose={() => sendInviteEmail.setAlert(null)}
        open={Boolean(sendInviteEmail.alert && sendInviteEmail.isSent)}
        title={"EMAIL SENT"}
        content={`Invite email was sent to user ${email}.`}
      />
    </>
  );
}

export default Alerts;
